var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "submit-tender" },
    [
      _c(
        "button",
        {
          class: _vm.className,
          attrs: {
            id: "submit_tender",
            type: "button",
            disabled: _vm.disabled,
          },
          on: {
            click: function ($event) {
              return _vm.init()
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("action.submit")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { ref: "chooseApprModal", attrs: { modalId: "choose-appr-modal" } },
        [
          _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("handover.submit.chooseApprover")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("HKLSelect", {
                staticClass: "submit-hkl-select",
                attrs: {
                  value: _vm.approverId || undefined,
                  options: _vm.approverHklOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.onApproverChange },
              }),
              _vm._v(" "),
              _vm.apprErrHint
                ? _c(
                    "span",
                    { staticClass: "form-error is-visible appr-error-message" },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.apprErrHint) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.closeApprModal()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.submitHandover()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.submit")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("modal", { ref: "alertModal", attrs: { modalId: "alert-modal" } }, [
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _c("p", { staticClass: "modal-pure-text" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.isHandover
                    ? _vm.$t("handover.submit.submitted")
                    : _vm.$t("takeback.submit.submitted")
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.navTo()
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("hint.okay")) + "\n      ")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }